export default __webpack_public_path__ + "static/gaming_service_user-c2867b0cb6af1cffa531b8f548e6e901.jpg";